
export default [

    {
        path: '/houTai',
        name: 'HouTai',
        component: () => import('@/page/houTai/index.vue'),
        children: [
            {
                path: '',
                redirect: "/houTai/miMa"
            },
            {
                path: '/houTai/zhangHao',
                component: () => import('@/page/houTai/zhangHao.vue'),
                meta: {
                    breadcrumb: [
                        {
                            breadcrumbName: "系统设置"
                        },
                        {
                            breadcrumbName: "账号管理"
                        },
                        {
                            breadcrumbName: "人员列表"
                        }
                    ]
                }
            },
            {
                path: '/houTai/quanXian',
                component: () => import('@/page/houTai/quanXian.vue'),
                meta: {
                    breadcrumb: [
                        {
                            breadcrumbName: "系统设置"
                        },
                        {
                            breadcrumbName: "账号管理"
                        },
                        {
                            breadcrumbName: "权限列表"
                        }
                    ]
                }
            },
            {
                path: '/houTai/jueSe',
                component: () => import('@/page/houTai/jueSe.vue'),
                meta: {
                    breadcrumb: [
                        {
                            breadcrumbName: "系统设置"
                        },
                        {
                            breadcrumbName: "账号管理"
                        },
                        {
                            breadcrumbName: "角色列表"
                        }
                    ]
                }
            },
            {
                path: '/houTai/miMa',
                component: () => import('@/page/houTai/miMa.vue'),
                meta: {
                    breadcrumb: [
                        {
                            breadcrumbName: "系统设置"
                        },
                        {
                            breadcrumbName: "个人中心"
                        },
                        {
                            breadcrumbName: "修改密码"
                        }
                    ]
                }
            },
            {
                path: '/houTai/guiGe',
                component: () => import('@/page/houTai/guiGe.vue'),
                meta: {
                    breadcrumb: [
                        {
                            breadcrumbName: "信息预设"
                        },
                        {
                            breadcrumbName: "入库预设"
                        },
                        {
                            breadcrumbName: "设备规格"
                        }
                    ]
                }
            },
            {
                path: '/houTai/wangGe',
                component: () => import('@/page/houTai/wangGe.vue'),
                meta: {
                    breadcrumb: [
                        {
                            breadcrumbName: "信息预设"
                        },
                        {
                            breadcrumbName: "出库预设"
                        },
                        {
                            breadcrumbName: "网格信息"
                        }
                    ]
                }
            },
            {
                path: '/houTai/yongHu',
                component: () => import('@/page/houTai/yongHu.vue'),
                meta: {
                    breadcrumb: [
                        {
                            breadcrumbName: "信息预设"
                        },
                        {
                            breadcrumbName: "出库预设"
                        },
                        {
                            breadcrumbName: "用户信息"
                        }
                    ]
                }
            },
            {
                path: '/houTai/diZhi',
                component: () => import('@/page/houTai/diZhi.vue'),
                meta: {
                    breadcrumb: [
                        {
                            breadcrumbName: "信息预设"
                        },
                        {
                            breadcrumbName: "出库预设"
                        },
                        {
                            breadcrumbName: "地址信息"
                        }
                    ]
                }
            },
            // {
            //     path: '/houTai/kuCun',
            //     component: () => import('@/page/houTai/kuCun.vue'),
            //     meta: {
            //         breadcrumb: [
            //             {
            //                 breadcrumbName: "业务查询"
            //             },
            //             {
            //                 breadcrumbName: "库存查询"
            //             },
            //             {
            //                 breadcrumbName: "库存信息"
            //             }
            //         ]
            //     }
            // },
            // {
            //     path: '/houTai/ruKu',
            //     component: () => import('@/page/houTai/ruKu.vue'),
            //     meta: {
            //         breadcrumb: [
            //             {
            //                 breadcrumbName: "业务查询"
            //             },
            //             {
            //                 breadcrumbName: "入库查询"
            //             },
            //             {
            //                 breadcrumbName: "入库记录"
            //             }
            //         ]
            //     }
            // },
            {
                path: '/houTai/chuKu',
                component: () => import('@/page/houTai/chuKu.vue'),
                meta: {
                    breadcrumb: [
                        {
                            breadcrumbName: "业务查询"
                        },
                        {
                            breadcrumbName: "出库查询"
                        },
                        {
                            breadcrumbName: "出库记录"
                        }
                    ]
                }
            },
            {
                path: '/houTai/anZhuang',
                component: () => import('@/page/houTai/anZhuang.vue'),
                meta: {
                    breadcrumb: [
                        {
                            breadcrumbName: "业务查询"
                        },
                        {
                            breadcrumbName: "安装查询"
                        },
                        {
                            breadcrumbName: "安装记录"
                        }
                    ]
                }
            },
          {
            path: '/houTai/daoChu',
            component: () => import('@/page/houTai/daoChu.vue'),
            meta: {
              breadcrumb: [
                {
                  breadcrumbName: "业务查询"
                },
                {
                  breadcrumbName: "导出查询"
                },
                {
                  breadcrumbName: "导出记录"
                }
              ]
            }
          },{
            path: '/houTai/shouHou',
            component: () => import('@/page/houTai/shouHou.vue'),
            meta: {
              breadcrumb: [
                {
                  breadcrumbName: "业务查询"
                },
                {
                  breadcrumbName: "售后查询"
                },
                {
                  breadcrumbName: "售后记录"
                }
              ]
            }
          }

        ]
    }
]



// WEBPACK FOOTER //
// ./src/router/houTai.js